import React from "react"
import Image from "components/image";
import RelatedArticleCard from "blocks/related-articles/related-article-card";
import Link from "components/link";
import { ReactComponent as Arrow } from "../../assets/fh_arrow.svg";
import useIsMobile from "helpers/useIsMobile";

import "blocks/theme-picker.scss";
import styles from "../feature-report/feature-report.module.scss"


const FeaturePost = ({ id, themePicker, altText, plainText, featurePostImage, linkTo }) => {
  const breakpoint = 992;
  const isMobile = useIsMobile(breakpoint);

  const articleType = "Campaign"

  let blocks = linkTo.element.pageBuilder
  let headerBlock = blocks.filter(block => block.typeHandle === "header")
  const { heading, introBody } = headerBlock.length ? headerBlock[0] : {};

  return (
    isMobile ?
      <div className={`${themePicker} ${styles.mobileFeatureContainer}`}>
        <RelatedArticleCard
          link={linkTo}
          id={id}
          articleType={articleType}
          altText={altText}
          articleImage={featurePostImage}
          header={heading}
          singleCard={true}
        />
      </div>

      :
      <div className={`${themePicker} ${styles.featureContainer}`}>
        <Link className={`border-${themePicker} ${styles.featureLink}`} {...linkTo} >
          <>
            {featurePostImage.length ? <Image alt={altText} title={featurePostImage[0].title} {...featurePostImage[0].optimized} /> : ""}
            <div className={styles.blogContent}>
              <p className={styles.typeHandle}>{articleType}</p>
              <h1 className={styles.headline}>{heading}</h1>
              <p className={styles.summary}>{plainText || introBody}</p>
              <figure className={styles.featurePostArrow}><Arrow /></figure>
            </div>
          </>
        </Link>
      </div>
  );
}

export default FeaturePost